import { mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  computed: {
    ...mapGetters(['currentEditPlan', 'basicConfig']),
    currentBoughtLicense() {
      return this.currentEditPlan?.cartInfo?.selected_number;
    },
    hasAccountDiscount() {
      return get(this.basicConfig, 'hasAccountDiscount', false);
    },
    isStandardPrice() {
      if (this.hasAccountDiscount) return true;
      return this.currentEditPlan?.isStandardPrice;
    },
  },
  methods: {
    // check current capacity is non standard price
    checkCurrentCapacityIsNonStandardPrice(capacity) {
      return !this.isStandardPrice && capacity === this.currentEditPlan?.capacity;
    },
    async mx_beforeSwitchCycle(oldPlan, newPlan) {
      return this.beforeSwitchCapacityHook(oldPlan, newPlan);
    },
    async beforeSwitchCapacityHook(oldPlan, newPlan) {
      return this.revertQuantityForNonStandardPrice(newPlan?.capacity, newPlan?.cartInfo?.selected_number);
    },
    revertQuantityForNonStandardPrice(newCapacity, newQuantity) {
      if (newCapacity === this.currentEditPlan?.capacity
        && !this.isStandardPrice
        && newQuantity <= this.currentBoughtLicense) {
        return Promise.resolve({ selected_number: this.currentBoughtLicense });
      }

      return Promise.resolve();
    },
  },
};
